import xhr from 'Common/utils/xhr'

const url = '/api/v1/flashcard_pdfs'

export const postFlashcardPdf = ({
  flashcards,
  layout,
  font,
  perPage,
  color,
}) =>
  xhr({
    url,
    method: 'POST',
    data: {
      flashcards: flashcards.map(({ id, image, imageGrayscale, title }) => ({
        id,
        image,
        imageGrayscale,
        title,
      })),
      layout,
      font,
      per_page: perPage,
      color,
    },
  })

export const getFlashcardPdf = async id => {
  const response = await xhr({
    url: `${url}/${id}`,
    method: 'GET',
  })
  if (response.data === false) throw new Error('PDF not ready yet!')
  return response
}
